// Third Party Imports
import React from 'react';

// HA Artifactory Imports
import {FormInput} from '@homeaway/react-form-components';
import {ButtonLink} from '@homeaway/react-buttons';
import {SVGIcon} from '@homeaway/react-svg';
import {SEARCH__24} from '@homeaway/svg-defs';

// Relative Imports
import {processTranslation} from '../utils/commonUtil';
import ContinueButtonHolder from '../ButtonHolder/ContinueButtonHolder';
import SearchSuggestion from './SearchSuggestion';
import SoftwareHelpPanel from './SoftwareHelpPanel';
import AlertBox from '../Alert/Alert';
import SubHead from '../SubHead/SubHead';
import SameSoftwareModal from './SameSoftwareModal';
import './SoftwareDetails.less';

class SoftwareDetails extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.prePopulateLocalState();
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    render() {
        let {
            translations,
            softwareNameValue,
            softwareSuggestions,
            softwareIdValue,
            softwareIdReadOnly,
            softwareNameError,
            softwareIdError,
            handleSoftwareNameChange,
            handleSoftwareIdChange,
            enableSoftwareIdField,
            enableContinueButton,
            handleContinueButtonClick,
            handleSoftwareSelect,
            handleDropDownDismiss,
            handleToggleFieldView,
            displaySuggestions,
            triggerEdapEventOnFocus,
            handleUnListedSoftwareClick,
            handleFindSoftwareUserID,
            displaySoftwareIdHelpPanel,
            dismissSidePanel,
            serviceError,
            handleAlertDismiss,
            handleSaveAndFinishOnClick,
            isSaveModalOpen,
            handleSaveModalClose,
            showSameSoftwareModal,
            handleSameSoftwareModalClose
        } = this.props;

        const softwareName = [];
        softwareName.push(softwareNameValue);

        return (
            <div id="softwareDetails" className="software-details">
                <div>
                    <div className="software-details-container">
                        <SubHead
                            translations={translations}
                            handleSaveAndFinishOnClick={handleSaveAndFinishOnClick}
                            isSaveModalOpen={isSaveModalOpen}
                            handleSaveModalClose={handleSaveModalClose}
                        />
                        {
                            (serviceError)
                                ? <div className="alert-panel">
                                    <AlertBox
                                        messageKey={serviceError}
                                        translations={translations}
                                        handleAlertDismiss={handleAlertDismiss}
                                        size={'sm'}
                                    />
                                </div>
                                : null
                        }
                        <div className="wrapper">
                            <div className="main-content-holder">
                                <div className="panel-head">
                                    <h1 className="head">{translations['ipmob.software_details.heading_1']}</h1>
                                    <span className="sub-head-grey">{translations['ipmob.software_details.heading_2']}</span>
                                </div>
                                <div className="input-container" aria-label="Big form">
                                    <div className="wrapper">
                                        <div className="content-col">
                                            <h5 className="sub-head">{translations['ipmob.software_details.subheading_1']}</h5>
                                        </div>
                                    </div>
                                    <div className="wrapper">
                                        <div className="content-holder input-holder">
                                            <FormInput
                                                id="softwareName"
                                                type="text"
                                                name="Software Name"
                                                label={translations['ipmob.software_details.label_1']}
                                                value={softwareNameValue}
                                                errorMsg={translations[softwareNameError]}
                                                onChange={handleSoftwareNameChange}
                                                onBlur={handleToggleFieldView}
                                                onFocus={triggerEdapEventOnFocus}
                                                maxLength="64"
                                                leftContent={<SVGIcon useFill inlineFlex markup={SEARCH__24}/>}
                                                autoComplete="off"
                                            />
                                            <SearchSuggestion
                                                softwareSuggestions={softwareSuggestions}
                                                handleSoftwareSelect={handleSoftwareSelect}
                                                handleDropDownDismiss={handleDropDownDismiss}
                                                displaySuggestions={displaySuggestions}
                                            />
                                        </div>
                                        <div className="help-text-holder ">
                                            <ButtonLink
                                                className="help-text-link"
                                                label={translations['ipmob.software_details.button_text_2']}
                                                onClick={handleUnListedSoftwareClick}
                                            />
                                        </div>
                                    </div>
                                    {
                                        (enableSoftwareIdField)
                                            ? (<div>
                                                <div className="wrapper">
                                                    <div className="content-col">
                                                        <h5 className="sub-head-normal">{processTranslation(translations['ipmob.software_details.subheading_2'], softwareName)}</h5>
                                                    </div>
                                                </div>
                                                <div className="wrapper">
                                                    <div className="content-col">
                                                        <div className="sub-sub-head">{translations['ipmob.software_details.subheading_5']}</div>
                                                    </div>
                                                </div>
                                                <div className="wrapper">
                                                    <div className="content-holder input-holder">
                                                        <FormInput
                                                            id="softwareId"
                                                            type="text"
                                                            name="Software User ID"
                                                            label={translations['ipmob.software_details.label_2']}
                                                            value={softwareIdValue}
                                                            errorMsg={translations[softwareIdError]}
                                                            onChange={handleSoftwareIdChange}
                                                            maxLength="64"
                                                            onFocus={triggerEdapEventOnFocus}
                                                            readOnly={softwareIdReadOnly}
                                                        />
                                                    </div>
                                                    <div className="help-text-holder">
                                                        <ButtonLink label={translations['ipmob.software_details.button_text_3']}
                                                            onClick={handleFindSoftwareUserID}
                                                        />
                                                    </div>
                                                </div>
                                            </div>)
                                            : null
                                    }
                                </div>
                            </div>
                            <div className="col-sm-4"/>
                        </div>
                        <ContinueButtonHolder
                            enableContinueButton={enableContinueButton}
                            handleContinueButtonClick={handleContinueButtonClick}
                            translations={translations}
                            continueButtonId={'softwareDetailsContinueBtn'}
                        />
                    </div>
                </div>
                {
                    (displaySoftwareIdHelpPanel) ? <div className="side-panel-backdrop"/> : null
                }
                <div className={(displaySoftwareIdHelpPanel) ? 'slide-in show from-right' : 'slide-in from-right'}>
                    <SoftwareHelpPanel onBlur={dismissSidePanel} translations={translations} onClose={dismissSidePanel}/>
                </div>
                <SameSoftwareModal
                    translations={translations}
                    isOpen={showSameSoftwareModal}
                    onClose={handleSameSoftwareModalClose}
                />
            </div>
        );
    }
}

export default SoftwareDetails;
